module.exports = __webpack_public_path__ + "static/media/info.4e19f647.svg";